<template>

  <div class="padded">

    <xolas-table
      table-ref="site-contractors-table"
      title="Contractors Statement"
      :url="'/contractor/site/' + siteId"
      hide-org-badge
      sort-field="started"
      :fields="fields"
      layer-component="siteContractor"
      :layer-args="{ id: 'id' }">

      <template #actions>
        <site-contractor-action :site-id="siteId" table-ref="site-contractors-table" />
      </template>

      <template #admin-action="props">
          <el-button v-if="isSuper() || isManager('finance')"
            class="hidden-md-and-down"
            type="danger" size="mini" icon="fa fa-trash-alt"
            aria-label="Delete contractor statement"
            @click="deleteRow(props.rowData)" circle>
          </el-button>
      </template>

    </xolas-table>

  </div>

</template>


<script>

import SiteContractorAction from '@/components/actions/SiteContractorAction'

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  components: {
    SiteContractorAction
  },

  props: {

    siteId: {
      type: Number,
      required: true
    },

  },



  methods: {

    deleted () {
      this.$events.emit('site-contractors-table-refresh-table')
    },

    deleteRow (row) {
      if (row) {
        this.deleteItem(this, row.id, '/contractors', 'Contractor ' + row.contractor.shortName + (row.type ? ' Type ' + row.type : (row.summary ? 'Summary: ' + row.summary : 'Inv. No: ' + row.invoiceNo)), this.deleted)
      }
    },

  },

  data () {
    return {

      fields: [
        {
          name: 'contractor.shortName',
          title: 'Short Name',
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type'
        },
        {
          name: 'summary',
          title: 'Summary',
          sortField: 'summary',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'started',
          title: 'Started',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'ended',
          title: 'Ended',
          callback: this.formatDateTime,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: 'Tax',
          callback: this.formatNumber,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatNumber,
          visible: this.showTax()
        },
        {
          name: '__slot:admin-action',
          visible: (this.isSuper() || this.isManager('finance'))
        }
      ]
    }
  }
}

</script>
